import _ from 'lodash';
import WixEvent from 'ui/events/WixEvent';
import imageUtils from 'privates/utils/imageUtils';


function getImageData(event) {
    let image;

    try {
        if (_.get(event, 'item')) {
            image = imageUtils.dataFormat.toUser(event.item);
        }
    } catch (e) {/*do nothing*/
    }

    return image;
}


/**
 * @callback $w.GalleryItemChangedEventHandler
 * @summary Handles events fired when a gallery moves to a new image.
 * @param {$w.GalleryItemChangedEvent} event The event that occurred.
 * @param {$w.$w} $w A selector function. The $w function enables event handlers
 *  to work with elements in [repeaters]($w.Repeater.html#repeating-callback-selector)
 *  and in the [global scope]($w.Repeater.html#regular-callback-selector).
 */

/**
 * @class GalleryItemChangedEvent
 * @summary Event that is fired when a gallery moves to a new image.
 * @memberof $w
 * @mixes $w.Event
 */
export default class GalleryItemChangedEvent extends WixEvent {
    constructor(target, event) {
        super(target, event);

        this.item = getImageData(event);
        this.itemIndex = event.imageIndex;

    }

    /**
     * @member item
     * @label property
     * @syntax
     * get item(): ImageItem|VideoItem|TextItem
     * @summary Gets the gallery item.
     * @snippet [GalleryEvent-item.es6=Get the event's item]
     * @type {$w.Gallery~ImageItem|$w.Gallery~VideoItem|$w.Gallery~TextItem}
     * @memberof $w.GalleryItemChangedEvent
     * @readonly
     */

    /**
     * @member itemIndex
     * @label property
     * @syntax
     * get itemIndex(): Number
     * @summary Gets the gallery item's index.
     * @type {external:Number}
     * @snippet [GalleryEvent-itemIndex.es6=Get the event's item index]
     * @memberof $w.GalleryItemChangedEvent
     * @readonly
     */
}



// WEBPACK FOOTER //
// ./js/modules/ui/events/GalleryItemChangedEvent.es6